import { RouteObject, DataRouter } from "react-router";
import { updateFieldExtent } from "../../../../../../API/fields";
import EditExtent from "./EditExtent";
import i18next from "i18next";
import { MessageLevel } from "../../../../../../Component/message-flash/MessageFlash";

const routes: RouteObject = {
  path: "edit-extent",
  Component: EditExtent,
  action: async ({ request, params }) => {
    if (!params.fieldId) return;

    const body = await request.text();
    const result = await updateFieldExtent({ body, fieldId: params.fieldId });

    return result.status < 300 ? MessageLevel.Success : MessageLevel.Error;
  },

  handle: {
    confirmLeave(router: DataRouter, to: string) {
      if (router.state.location.pathname.includes(to)) {
        return false;
      }
      return confirm(i18next.t("prompt.confirm.cancel_edit") as string);
    },
  },
};

export default routes;
